export default __webpack_public_path__ + "static/media/wait_refresh_page.19141805.png";